import { useTranslation } from '@unifyapps/i18n/client';
import SvgBack2 from '@unifyapps/icons/outline/Back2';
import SvgSettings01 from '@unifyapps/icons/outline/Settings01';
import SvgXClose from '@unifyapps/icons/outline/XClose';
import { Box } from '@unifyapps/ui/components/Box';
import type { FeaturedIconColors } from '@unifyapps/ui/components/FeaturedIcon';
import { IconButton } from '@unifyapps/ui/components/IconButton';
import { Pill } from '@unifyapps/ui/components/Pill';
import { Typography } from '@unifyapps/ui/components/Typography';
import clsx from 'clsx';
import { useUnopenedNotificationsCount } from '../hooks/useUnopenedNotificationsCount';

export function PanelHeader({
  onSettingsClick,
  onClose,
  color,
  scheme,
}: {
  onSettingsClick: () => void;
  onClose: () => void;
  color?: FeaturedIconColors;
  scheme?: 'light' | 'dark';
}) {
  const { t } = useTranslation(['common']);

  const { count: unopenedNotificationsCount, isLoading } = useUnopenedNotificationsCount();

  return (
    <>
      <Box className="gap-md flex items-center">
        <Box className="gap-md flex items-center">
          <Typography color="text-primary" variant="text-sm" weight="semi-bold">
            {t('common:Notifications')}
          </Typography>
        </Box>
        {isLoading || !unopenedNotificationsCount ? null : (
          <Pill
            className={clsx(
              '!rounded-xs py-xxs px-xs h-4',
              scheme === 'dark' ? 'border-brand-secondary bg-brand-secondary' : '',
            )}
            color="brand"
            label={String(unopenedNotificationsCount)}
            labelClassName="text-xxxs"
            size="xs"
            variant="soft"
          />
        )}
      </Box>
      <Box className="flex items-center">
        <IconButton
          color="neutral"
          Icon={SvgSettings01}
          iconClassName="!size-[14px]"
          onClick={onSettingsClick}
          size="xs"
          variant="soft"
        />
        <IconButton
          color="neutral"
          Icon={SvgXClose}
          iconClassName="!size-4"
          onClick={onClose}
          size="xs"
          variant="soft"
        />
      </Box>
    </>
  );
}

export function PreferencesHeader({
  onBack,
  onClose,
}: {
  onBack: () => void;
  onClose: () => void;
}) {
  const { t } = useTranslation(['common']);

  return (
    <>
      <Box className="gap-md flex items-center">
        <Box className="flex items-center">
          <IconButton color="neutral" Icon={SvgBack2} onClick={onBack} size="xs" variant="soft" />
        </Box>
        <Typography color="text-primary" variant="text-sm" weight="semi-bold">
          {t('common:NotificationSettings')}
        </Typography>
      </Box>
      <Box className="flex items-center">
        <IconButton color="neutral" Icon={SvgXClose} onClick={onClose} size="sm" variant="soft" />
      </Box>
    </>
  );
}
